const divModalCloneCheck = {
  text1: 'The Checklist',
  text2: 'will be cloned to the selected Service Type and Periodicity.',
};

export default divModalCloneCheck;
